/* Gallery ↔ variant-picker ↔ quote/sample form glue.
 *
 * This file wires three related concerns; kept together because they all hang off
 * the variant-picker event lifecycle and the file is already loaded on every
 * product page via snippets/product-gallery.liquid.
 *
 *   1) Thumbnail click → variant select.
 *      snippets/product-gallery.liquid renders every product image as a thumbnail.
 *      For thumbnails whose media is a variant's featured_media (a colourway
 *      swatch), clicking selects that variant via the existing radio in
 *      snippets/variant-picker.liquid, so hero image / swatch highlight / cart
 *      variant all move in lockstep.
 *
 *   2) variant:change → quote & sample hidden-field sync.
 *      snippets/request-quote-form.liquid and snippets/product-sample-box.liquid
 *      render variant-specific hidden fields at Liquid render time (variant_id,
 *      product_image, properties[_Parent variant id], properties[codice prodotto]).
 *      Nothing else updates them when the customer changes variant client-side,
 *      so submitting after a swatch change sent the FIRST variant's data. Bug
 *      surfaced as customer orders on wrong colour. Fixed by listening on the
 *      form-dispatched 'variant:change' CustomEvent (theme.js L3441) — bubbles
 *      to document; matches the pattern product-cms.js already uses at L12/L284.
 *
 *   3) Quote submit → colour name prefix in message body.
 *      Human-readable fallback so the merchant sees the selected colourway in
 *      the email even if the Hostinger backend ever mishandles variant_id.
 *      Idempotent — re-submits after a validation error replace, not stack.
 *      Bound in CAPTURE phase on document so it runs BEFORE product-cms.js's
 *      form-bound submit handler (bubble phase) reads new FormData(form) at L147.
 */
(function () {
  'use strict';

  if (window.__galleryThumbVariantLoaded) return;
  window.__galleryThumbVariantLoaded = true;

  // ============================================================
  // (1) Thumbnail click → variant select
  // ============================================================
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var btn = target.closest('.product-gallery__thumbnail[data-variant-id]');
    if (!btn) return;

    var optionPosition = btn.dataset.optionPosition;
    var optionValueId = btn.dataset.optionValueId;
    if (!optionPosition || !optionValueId) return;

    var gallery = btn.closest('product-gallery');
    if (!gallery) return;

    var formId = gallery.getAttribute('form');
    if (!formId) return;

    // Radio id TAIL per snippets/variant-picker.liquid L145/L159. The actual live
    // id carries an "option-value-{index}-{section.id}-" prefix from L172's render
    // through option-value.liquid; match on the unique tail via [id$=…].
    var inputIdSuffix = formId + '-option' + optionPosition + '-' + optionValueId;
    var input = document.querySelector('input[type="radio"][id$="' + inputIdSuffix + '"]');

    // Guard: quote-only PoR pages have no picker → querySelector returns null. Silent no-op.
    if (!input) return;
    if (input.checked) return;

    // Selection pattern per snippets/option-value.liquid L131 — go through the picker,
    // never write the form's hidden id directly.
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ============================================================
  // (2) variant:change → hidden-field sync on quote + sample forms
  // ============================================================
  var lastVariant = null;

  function absoluteImageSrc(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    if (src.indexOf('http') === 0) return src;
    return 'https:' + src;
  }

  function syncQuoteForms(variant) {
    var forms = document.querySelectorAll('form[data-quote-form]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];

      var variantIdField = form.querySelector('input[name="variant_id"]');
      if (variantIdField && variant.id != null) {
        variantIdField.value = String(variant.id);
      }

      // product_image field in snippets/request-quote-form.liquid uses
      // product.featured_image at Liquid render → static first-variant image.
      // Update to the current variant's featured image so the merchant email
      // shows what the customer was looking at.
      var productImageField = form.querySelector('input[name="product_image"]');
      if (productImageField && variant.featured_image && variant.featured_image.src) {
        productImageField.value = absoluteImageSrc(variant.featured_image.src);
      }
    }
  }

  function syncSampleForms(variant) {
    var forms = document.querySelectorAll('form[data-sample-add-form]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];

      var parentVariantIdField = form.querySelector(
        'input[name="properties[_Parent variant id]"]'
      );
      if (parentVariantIdField && variant.id != null) {
        parentVariantIdField.value = String(variant.id);
      }

      // "codice prodotto" == variant.sku (with product.handle fallback per snippet
      // L23). Only overwrite when the new variant has a SKU; blank SKU leaves
      // whatever the initial render put in place.
      var skuField = form.querySelector('input[name="properties[codice prodotto]"]');
      if (skuField && variant.sku) {
        skuField.value = variant.sku;
      }

      // Colore = variant.title (single-option products give the raw colour name).
      // Distinct value per colourway → both the max-1 check (product-cms.js keys on
      // _Parent variant id) and the cart line rendering ("Campione — <Design> —
      // <Colore>") depend on this being current when the form submits.
      var colourField = form.querySelector('input[name="properties[Colore]"]');
      if (colourField && variant.title) {
        colourField.value = variant.title;
      }
    }
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    lastVariant = variant;
    syncQuoteForms(variant);
    syncSampleForms(variant);
  });

  // ============================================================
  // (3) Quote submit → prepend "Colore selezionato: <name>" (idempotent)
  // ============================================================
  function getInitialVariantFromPicker() {
    var script = document.querySelector('variant-picker script[data-variant]');
    if (!script || !script.textContent) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function currentVariantName() {
    var v = lastVariant || getInitialVariantFromPicker();
    if (!v) return null;
    // Single-option products: v.title = "Ambra". Multi-option: "Ambra / Small".
    // v.options[0] is also the primary option value string for single-option products.
    return v.title || (v.options && v.options[0]) || null;
  }

  var PREFIX_TAG = 'Colore selezionato:';

  function applyColourPrefix(messageField, colourName) {
    var newPrefix = PREFIX_TAG + ' ' + colourName;
    var current = messageField.value || '';

    if (current.indexOf(PREFIX_TAG) === 0) {
      // Prefix already present (from a prior submit attempt / user retry).
      // Strip the first line + one optional blank line, then re-prepend with
      // the CURRENT colour — otherwise a colour switch between retries wouldn't take.
      var nlIdx = current.indexOf('\n');
      var rest = nlIdx >= 0 ? current.substring(nlIdx + 1) : '';
      if (rest.charAt(0) === '\n') rest = rest.substring(1);
      messageField.value = rest.length > 0 ? newPrefix + '\n\n' + rest : newPrefix;
    } else {
      var trimmed = current.trim();
      messageField.value = trimmed.length > 0 ? newPrefix + '\n\n' + trimmed : newPrefix;
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.hasAttribute('data-quote-form')) return;

    var messageField = form.querySelector('textarea[name="message"]');
    if (!messageField) return;

    var name = currentVariantName();
    if (!name) return;

    applyColourPrefix(messageField, name);
  }, true); // capture phase → runs before product-cms.js's form-bound submit handler
})();
